module.exports = __webpack_public_path__ + "img/hippo.fc1960b6.png";